import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import Image from '../WhyHostFormBlock1/Image';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../../locale/jsonMessages';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock5.css';

const block5ActiveFields = ['workTitleHeading', 'peaceTitle1', 'peaceContent1', 'peaceTitle2', 'peaceContent2'];

class WhyHostFormBlock5 extends Component {

  render() {

    const { error, handleSubmit, submitting, workImage4, workImage4loader, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.WhyBecomeOwnerBlock5} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className='siteAdminCenterContainer'>
              <div className='siteAdminDropZoneWrapper'>
                <label className={cx('commonLabelText', cs.spaceBottom3)}><FormattedMessage {...messages.imageLabel} /></label>
                <Image image={workImage4} fieldName={"workImage4"} loader={workImage4loader} />
              </div>
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicWhyHostInfoBlock"
                component={FieldArrayComponent}
                activesFields={block5ActiveFields}
                filedName="dynamicWhyHostInfoBlock"
                selectedLanguage={selectedLanguage}
                label={formatMessage(messages.workTitleHeading)}
                placeholder={formatMessage(messages.workTitleHeading)}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

WhyHostFormBlock5 = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostFormBlock5);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  workImage4loader: state?.loader?.workImage4,
  workImage4: selector(state, 'workImage4'),
  selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, {})
)(WhyHostFormBlock5);
